import(/* webpackMode: "eager" */ "/tmp/build_ed8c862a/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_ed8c862a/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","error","loading","success"] */ "/tmp/build_ed8c862a/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/tmp/build_ed8c862a/src/app/categories/[slug]/CategoryMessages.jsx");
